import { formatDate, parseDate } from '../../utils/date';

export const getValues = response => ({
  ...response,
  alaLevels: response.alaLevels.map(value => ({ value, label: typeof value === 'string' && value.includes('ALA') ? value : `ALA${value}` })),
  exPeriod: !!response.exStartDate,
  autoApprovalOn: response.autoApprovalOn,
  operator: response.postalOperator,
  autoApprovalAlaLevel: {
    value: response.autoApprovalAlaLevel,
    label: response.autoApprovalAlaLevel,
  },
});

export const getPayload = (values) => {
  const payload = {
    id: values.id,
    alaLevels: values.alaLevels.map(item => item.value),
    origin: values.origin,
    destination: values.destination,
    postalOperator: values.operator,
    carrier: values.carrier,
    startDate: values.startDate,
    stopDate: values.stopDate,
    autoApprovalOn: values.autoApprovalOn,
    autoApprovalAlaLevel: values.autoApprovalAlaLevel ? values.autoApprovalAlaLevel.value : '',
  };

  if (values.exPeriod && values.exStartDate && values.exStopDate) {
    payload.exStartDate = values.exStartDate;
    payload.exStopDate = values.exStopDate;
  }

  return payload;
};

export const validateDates = (values, newWarning) => {
  const dateRegEx = /^(\d{2}[/]\d{2}[/]\d{4})$/;
  if (!dateRegEx.test(values.startDate)) {
    newWarning('Invalid Start Date value');
    return false;
  }

  if (!dateRegEx.test(values.stopDate)) {
    newWarning('Invalid End Date value');
    return false;
  }

  if (parseDate(values.startDate) < parseDate(formatDate(new Date()))) {
    newWarning('Start Date should be in the future!', 5);
    return false;
  }

  if (parseDate(values.stopDate) < parseDate(values.startDate)) {
    newWarning('End Date should be after Start Date!', 5);
    return false;
  }

  return true;
};
